// extracted by mini-css-extract-plugin
export default {"anchor":"styles_anchor__b8jgy"};